angular.module('salesPath2')
  .controller('initCtrl', ['sp2Loader', '$timeout',
    function(sp2Loader, $timeout) {
      $timeout(function() {
        sp2Loader.processUrl();
        sp2Loader.dispatchAction();
      }, 0);
    }
  ]);